import { render, staticRenderFns } from "./RushRaceInfo.vue?vue&type=template&id=2f3d74c3&"
import script from "./RushRaceInfo.vue?vue&type=script&lang=js&"
export * from "./RushRaceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports